var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputDropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 'video'),expression:"view == 'video'"}],staticClass:"mt-5 mx-5",attrs:{"options":_vm.videoSourceList,"model":_vm.videoSource,"label":"Select video input","optionLabel":"text","value":"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }